import Cookies from 'js-cookie';
import {
  existsCookie, addCookie, getCookie, removeCookie,
} from 'Shared/util/cookies';

export const getSessionCookie = () => {
  const sessionCookie = Cookies.get('KafOnline.UserSession');
  return sessionCookie;
};

export const setSessionCookie = (session) => {
  Cookies.remove('KafOnline.UserSession');
  let cookie;
  if (session !== '') {
    cookie = Cookies.set('KafOnline.UserSession', session, { secure: true, sameSite: 'lax' });
  }
  return cookie;
};

export const setSessionCookieHasExpired = () => {
  Cookies.remove('KafOnline.UserSession');
  Cookies.remove('KafOnline.ActiveCompanyId');
};

export const hasValidSessionCookie = () => {
  const session = getSessionCookie();
  if (session) {
    return session !== 'expired'; // this check can be removed sometime in the future (e.g. after 2022-01-01)
  }
  return false;
};


const ACTIVE_COMPANY_COOKIE_ID = 'KafOnline.ActiveCompanyId';

export const getActiveCompanyId = () => {
  if (existsCookie(ACTIVE_COMPANY_COOKIE_ID)) {
    const value = getCookie(ACTIVE_COMPANY_COOKIE_ID);
    if (value) {
      return parseInt(value, 10);
    }
  }
  return 0;
};

export const setActiveCompanyId = (activeCompanyId) => {
  removeCookie(ACTIVE_COMPANY_COOKIE_ID);
  if (activeCompanyId > 0) {
    addCookie(ACTIVE_COMPANY_COOKIE_ID, activeCompanyId.toString());
  }
};
